module.exports = __webpack_public_path__ + "img/benadryl_extra_strength_allergy_releif.5ecb89b1.png";